import {ContextProvider} from "./context/ContextProvider";
import {RouterProvider} from "react-router-dom";
import router from "./routes/router";
import React from "react";
import { ModalProvider } from "./context/ModalContext";

function App() {
  return (
    <React.StrictMode>
      <ContextProvider>
        <ModalProvider>
          <RouterProvider router={router}/>
        </ModalProvider>
      </ContextProvider>
    </React.StrictMode>
  )
}

export default App
